module.exports = __webpack_public_path__ + "img/Eaton.aec6f156.png";